import React, { useState } from "react";
import withRouter from "../../../Components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useMutation } from "react-query";
import { authUser } from "../services/authApi";
import "../../../assets/login_page_assets/css/login.css";
import loginImage from "../../../assets/login_page_assets/images/login.jpg";
import { Button, Form, FormFeedback, Input, Label, Spinner } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import fleetFix from "../../../assets/login_page_assets/images/FleetFixLogoBlack.png";
const checkEmailExists = async (email) => {
  const response = await fetch(`http://41.82.226.245:2080/api/v1/users/email/${email}`);
  if (!response.ok) {
    throw new Error('Email non trouvé');
  }
  return response.json();
};

const ForbiddenPassword = (props) => {
  const { t } = useTranslation();

  document.title = `Connexion | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  const [error, setError] = useState("");
  const [emailExists, setEmailExists] = useState(false);
  const [isLoadingEmailCheck, setIsLoadingEmailCheck] = useState(false); 

  const { isLoading, mutate } = useMutation(authUser, {
    onSuccess: (data) => {
      if (data?.isAuthorized) {
        toast.success(t("login.successMessage"), {
          position: "top-right", 
          autoClose: 5000,  
          style: {
            backgroundColor: "#28a745",  
            color: "white", 
          },
        });

        setTimeout(() => {
          props.router.navigate("/récupération-de-mot-de-pass");
        }, 2000);
      } else {
        setError(t("login.invalidCredentials"));
        sessionStorage.clear();
        toast.error(t("login.errorMessage"), {
          position: "top-right",  
          autoClose: 5000,  
        });
      }
    },
    onError: (error) => {
      setError(error.message || t("login.genericError"));
      toast.error(t("login.genericError"), {
        position: "top-right",  
        autoClose: 5000,  
      });
    },
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Email est requis").email("Email invalide"),
    }),
    onSubmit: (values) => {
      const { email } = validation.values;
      const formData = {
        email: email,
        grant_type: process.env.REACT_APP_GRANT_TYPE,
        client_id: process.env.REACT_APP_CLIENT_ID,
      };
      mutate(formData);
    },
  });
  const handleButtonClick = async () => {
    const email = validation.values.email;
    if (!email || !validation.isValid) {
      toast.error(t("login.invalidEmail"), { 
        position: "top-right", 
        autoClose: 5000, 
      });
      return;
    }

    setIsLoadingEmailCheck(true); 

    try {
      await checkEmailExists(email);
      toast.success(t("login.emailExists"), { 
        position: "top-right", 
        autoClose: 5000, 
      });
      props.router.navigate("/récupération-de-mot-de-pass", { state: { email } }); 
    } catch (error) {
      toast.error(t("login.emailNotFound"), { 
        position: "top-right", 
        autoClose: 5000, 
      });
    } finally {
      setIsLoadingEmailCheck(false);  
    }
  };

  return (
    <div>
      <ToastContainer />

      <div className="container-login">
        <div className="login-image">
          <img src={loginImage} alt="Background" className="background-img" />
        </div>
        <div className="login-card" style={{ borderRadius: "30px", marginTop: "-50px", maxWidth: '550px', height: 'auto' }}>
          <div className="login-form" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <h3 className="h3">
              <div className="check-text-container">
                <img src={fleetFix} style={{ width: '166px', height: '28px', top: '121px', left: '667px' }} alt="Check" className="login-icon" />
                <span  style={{ fontSize: "29px",fontWeight: "700px", color: "#252525",fontFamily:'Raleway',marginTop:'50px'}}>{t("login.texte")}</span>
                <span style={{ fontSize: "17px", fontWeight: "400px", color: "#5D5D5D", fontFamily: 'Gelix', marginTop: '30px' }}>
                  Gardez un œil sur chaque véhicule, optimisez les itinéraires et
                </span>
                <span style={{ fontSize: "17px", fontWeight: "400px", color: "#5D5D5D", fontFamily: 'Gelix' }}>
                  réduisez vos coûts d’exploitation.
                </span>
              </div>
            </h3>
            <div className="separator-container">
              <div className="separator-line"></div>
              <span className="separator-text" style={{ fontSize: "20px", fontWeight: "500px", color: "#252525", fontFamily: 'Raleway' }}>
                {t("lockScreen.forbiddenPassword")}
              </span>
              <div className="separator-line"></div>
            </div>
            {error && <div className="alert alert-danger">{error}</div>}
            <Form onSubmit={validation.handleSubmit} style={{ flex: 1 }}>
              <div className="mb-4">
                <div className="mb-3"style={{marginLeft:'20px',marginRight:'20px'}}>
                  <Input
                    style={{ color: '#8B8B8B', fontFamily: 'Lato', fontWeight: '400px', fontSize: '15px' ,
                      borderColor:'#CDCDCD',
                      borderWidth: validation.touched.username && validation.errors.username ? '1px' : '1px', // Bordure fine (1px)
                    }}
                    name="email"
                    id="email"
                    className="form-control pe-5"
                    placeholder={t("login.renseignEmail")}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email}
                    invalid={validation.touched.email && validation.errors.email}
                  />
                  <FormFeedback>{validation.errors.email}</FormFeedback>
                </div>
              </div>
            </Form>
            <div style={{ marginTop: "10px", marginBottom: "100px" ,marginLeft:'20px',marginRight:'20px'}}>
              <Button
                style={{ backgroundColor: "#000000", color: "white", fontFamily: 'Gelix', fontWeight: '500px', fontSize: '17px' }}
                onClick={handleButtonClick} 
                disabled={!(validation.isValid && validation.dirty)}  
                className="form-control btn btn-soft-success pe-5 login-fc"
              >
                {isLoadingEmailCheck ? <Spinner size="sm" /> : t("login.send")}
              </Button>
            </div>
            <div className="element-1">
              <span style={{ fontSize: "15px", fontWeight: "400px", color: "#252525", fontFamily: 'Gelix' }}>
                {t("login.compte")}
              </span>
              <a href="/récupération-de-mot-de-pass"
                style={{ fontSize: "15px", fontWeight: "500px", color: "#E97D00", textDecoration: "underline", fontFamily: 'Gelix' }}
              >
                {t("login.connected")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(ForbiddenPassword);
